// src/services/verifyService.js
import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../firebaseConfig"; // ensure you export app in your config

const functions = getFunctions(app);

export async function sendEmailOtp(email) {
  const fn = httpsCallable(functions, "sendEmailOtp");
  const { data } = await fn({ email });
  return data; // {ok:true}
}

export async function verifyEmailOtp(email, code) {
  const fn = httpsCallable(functions, "verifyEmailOtp");
  const { data } = await fn({ email, code });
  return !!data?.ok;
}

export async function sendSmsOtp(phone) {
  const fn = httpsCallable(functions, "sendSmsOtp");
  const { data } = await fn({ phone });
  return data;
}

export async function verifySmsOtp(phone, code) {
  const fn = httpsCallable(functions, "verifySmsOtp");
  const { data } = await fn({ phone, code });
  return !!data?.ok;
}
